// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  name: 'dev',
  'apiServer': {
    'apiConsumerKey': 'fdcc0bf4d5e8ba1e9fe39b9ae404e861TRNmENtRynX2KQkc',
    'apiConsumerSecret': 'ddf2822702c88a754cc7df20d6e8bac0fc57d628d17dfc11f9ff2517ecb6ee04kXySxGAcGb5VUEeO'
  },

  auth0: {
    authUrl: 'https://theprintlife.us.auth0.com/authorize',
    clientId: 'nHzNGqpTA6mDoHGn6U0kitnDqRoxjfId',
    client_secret:'FSAOzjhpc5PXDTK8nT1XYSPfXi-rD1mNbrsKSWwpOTRQ-9l9_pB1wiZg_in9X6-4',
    redirectUri: 'https://staging.theprintlife.com/login',
    getAuth0UserToken: 'https://theprintlife.us.auth0.com/oauth/token',
    getauth0UserInfo: 'https://theprintlife.us.auth0.com/userinfo',
  },

  stripe: {
    authUrl: 'https://connect.stripe.com/oauth/authorize',
    clientId: 'ca_NTwynPO6i82NCjDjWKuY12JOPm3TAKK0',
    client_secret:'sk_test_51LDNsASJwg5fo5aaEc60ptwcKyEkgZzAOWIUPZ6NRvxpr0SY3pX5NSm6whEB4rFk5ZnOu4ToJ1S2WsJLVRMPd0a600d5VPOMrV',
    redirectUri: 'https://staging.theprintlife.com/settings/api-info/paymentProcessors',
    tokenEndpoint:'https://connect.stripe.com/oauth/token'
  },

  googleOAuth2: {
    authUrl: 'https://accounts.google.com/o/oauth2/auth',
    clientId: '160446822312-j12gr7t1bdvlntpah7nar2a5gc8m20ea.apps.googleusercontent.com',
    clientSecret: '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',
    redirectUri: 'https://staging.theprintlife.com/settings/smtp-mail-settings',
    tokenEndpoint:'https://oauth2.googleapis.com/token'
  },

  outlookOAuth2: {
    authUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
    clientId: '1a0d624b-93c8-4937-a1a0-5b991cbe4475',
    clientSecret: 'w3Q8Q~NUJ_spfAMK7IYYxkHPEwyaikcXThI5Aa9F',
    redirectUri: 'https://staging.theprintlife.com/settings/smtp-mail-settings',
    tokenEndpoint:'https://login.microsoftonline.com/common/oauth2/v2.0/token'
  },

  squareupOAuth2: {
    authUrl: 'https://connect.squareupsandbox.com/oauth2/authorize',
    clientId: 'sandbox-sq0idb-CtuDGP7PTMKcXvgifgaDUg',
    clientSecret: 'sandbox-sq0csb-NaQmaQF0iJ8rA8Tg5vkaiTk9r1Q3Z1C1scXcK7ti590',
    redirectUri: 'https://staging.theprintlife.com/settings/api-info/paymentProcessors'
  },

  recaptcha: {
    siteKey: '6LfxSk0qAAAAABEhxII88r-CzcG50SFRhNnSRK8k'
  },

  // Staging credentials

  'API_URL': 'https://stagingapi.theprintlife.com',
  'Admin_URL': 'https://staging.theprintlife.com/login',
  'Client_URL': 'https://staging.theprintlife.com/login',
  'Public_URL':'https://staging.theprintlife.com/',
  'Store_URL': 'merchshoplive.com/store',
  'PublicQuoteBuilder_URL':'project-builder.app',
  'Old_Client_URL' : 'https://oldlogin.theprintlife.com/login',

  PAYPAL_ENV_MODE: 'sandbox', //sandbox/production
  SQUAREUP_URL:"https://sandbox.web.squarecdn.com/v1/square.js"
  // SQUAREUP_URL:"https://web.squarecdn.com/v1/square.js"
};




// WEBPACK FOOTER //
// /var/www/staging.theprintlife.com/src/environments/environment.ts